import { ErrorNotificationInline } from "src/context/errorHandler/ErrorNotificationInline"
import { withErrorHandler } from "src/context/errorHandler/withErrorHandler"
import { SpecialEquipmentEdit } from "./components/specialEquipmentEdit/SpecialEquipmentEdit"
import { useSpecialEquipmentEdit } from "./hooks/useSpecialEquipmentEdit/useSpecialEquipmentEdit"
import type { UseSpecialEquipmentEditProps } from "./hooks/useSpecialEquipmentEdit/useSpecialEquipmentEdit"

export const SpecialEquipmentEditContainer = withErrorHandler((props: UseSpecialEquipmentEditProps) => {
	const equipmentEdit = useSpecialEquipmentEdit(props)

	return (
		<>
			<ErrorNotificationInline />
			<SpecialEquipmentEdit {...equipmentEdit} />
		</>
	)
})
